import $ from 'jquery';
import { Component } from '../core/component';

export class ReadMore extends Component {
    constructor() {
        super();
        this.selector = '.js-expand-content';
    }

    init() {
        /* eslint-disable no-unused-vars */
        this.$elements.each((index, element) => {
            /* eslint-disable no-unused-vars */
            let seemore = false;
            $(element).on('click', (e) => {
                const $expand = $(element).parent('.expandable');
                if (seemore === false) {
                    $expand.addClass('expandable--expanded');
                    $(element).text('');
                    seemore = true;
                } else if (seemore === true) {
                    $expand.removeClass('expandable--expanded');
                    $(element).text('Continue Reading...');
                    seemore = false;
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/readMore.js